import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import auth from './services/auth'

Vue.config.productionTip = false

// Init adal authentication - then create Vue app.
auth.initialize().then(_ => {
    initVue();
}, _ => {
    initVue();
});

function initVue(){
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
}